export const ContactGeneralAttributes = {
  ContactTypeId: 1,
  CompanyTypeId: 2,
  isEncrypted: 0,
  defaultAttributeId: 0,
  PersonalEmail1: 1,
  PersonalEmail2: 2,
  BusinessEmail1: 3,
  BusinessEmail2: 4,
  BusinessEmail3: 5,
  ChBxPersonalEmail1: 6,
  ChBxPersonalEmail2: 7,
  ChBxBusinessEmail1: 8,
  ChBxBusinessEmail2: 9,
  ChBxBusinessEmail3: 10,
  HomePhone1: 11,
  HomePhone2: 12,
  BusinessPhone1: 13,
  BusinessPhone2: 14,
  MobilePhone: 15,
  FaxNumber: 16,
  OtherPhone: 17,
  OtherFax: 18,
  HomeFax: 19,
  CarPhone: 20,
  SocialSecurity: 21,
  TaxIDNumber: 22,
  Anniversary: 23,
  SpouseName: 24,
  AnnualIncome: 25,
  EstimateAssest: 26,
  RepID: 27,
  IntroductionDate: 28,
  RankID: 29,
  LeadID: 30,
  RepTypeID: 31,
  ReferrerID: 32,
  PrimaryContactID: 33,
  ContactSource: 34,
  DateFounded: 35,
  Department: 36,
  Gender: 37,
  Honorific: 38,
  IsRIA: 39,
  LegalName: 40,
  BoardMember: 41,
  DoNotEmail: 42,
  ReceivesEstimates: 43,
  BusinessPhone1Extension: 44,
  BusinessPhone2Extension: 45,
  DateofDeath: 46,
  WebUrl: 47,
  IsPublic: 48,
  Industry: 49,
  NumberofEmployees: 50,
  YearFounded: 51,
  AnnualRevenue: 52,
  LinkedInAddress: 53,
};

export const TasksEntityType = {
Account:1,
Contact:0
}
